/**
 * Internal GEP feature name → player-friendly label.
 *
 * Mirror of packages/models/src/platform/playerFriendlyFeatureLabels.ts.
 * Duplicated here because web cannot depend on @devour/models (backend-only
 * package) but renders the same labels in degradation banners + status chips.
 * Keep in sync when adding new feature mappings on the backend.
 */
export const PLAYER_FRIENDLY_FEATURE_LABELS: Record<string, string> = {
    match_info: "Match results",
    match_start: "Match start",
    match_end: "Match end",
    match_id: "Match ID",
    match_outcome: "Match outcome",
    match_phase: "Match phase",
    match_quality: "Match quality",

    kill: "Kills",
    kills: "Kills",
    kill_feed: "Kill feed",
    death: "Deaths",
    death_count: "Deaths",
    assist: "Assists",
    assists: "Assists",
    damage: "Damage",
    damage_dealt: "Damage dealt",
    damage_taken: "Damage taken",
    headshot: "Headshots",
    revive: "Revives",

    round: "Rounds",
    round_start: "Round start",
    round_end: "Round end",
    round_won: "Round won",
    round_lost: "Round lost",
    round_outcome: "Round result",

    score: "Match score",
    team_score: "Team score",
    player_score: "Player score",
    scoreboard: "Scoreboard",
    teamScore: "Team score",
    matchScore: "Match score",

    rank: "Player rank",
    tier: "Rank tier",
    division: "Division",
    mmr: "MMR",
    elo: "ELO",
    elo_points: "ELO points",
    rating: "Rating",
    competitive_rank: "Competitive rank",
    skill_group: "Skill group",
    sr: "Skill rating (SR)",
    rp: "Rank points",
    lp: "League points",
    playlistsRank: "Playlist rank",
    playersRank: "Player rank",
    playerRank: "Player rank",
    player_rank: "Player rank",
    battlegroundsRating: "Battlegrounds rating",
    arenaScore: "Arena score",
    currentRp: "Rank points",
    placement: "Placement",
    placement_match_number: "Placement match",

    game_info: "Game info",
    game_state: "Game state",
    game_mode: "Game mode",
    gameMode: "Game mode",
    gameQueueType: "Queue type",
    queue_type: "Queue type",
    queueId: "Queue ID",
    is_ranked: "Ranked indicator",
    isRanked: "Ranked indicator",

    map: "Map",
    map_info: "Map info",
    map_name: "Map name",
    level: "Level",
    location: "Location",
    zone: "Zone",
    phase: "Phase",

    server_info: "Server info",
    serverInfo: "Server info",
    server_type: "Server type",

    mutators: "Game mutators",
    mutatorSettings: "Game mutators",
    custom_rules: "Custom rules",

    weapon: "Weapon",
    primary_weapon: "Primary weapon",
    weapon_used: "Weapon used",
    inventory: "Inventory",
    loadout: "Loadout",

    summoner_info: "Summoner info",
    local_player: "Local player",
    localPlayer: "Local player",
    me: "Player profile",
    player_id: "Player ID",
    account_id: "Account ID",

    bomb_planted: "Bomb plant",
    bomb_defused: "Bomb defuse",
    buy_phase: "Buy phase",

    placement_rank: "Final placement",
    teammates: "Teammates",
    squad: "Squad",
};
